import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Heading,
  List,
  ListItem,
} from "@chakra-ui/react";
import type { APIListingAgentUpdateEntry } from "models/types/api-listing";
import { Link } from "react-router-dom";
import { FeedbackListItem } from "modules/vendor-portal/screens/overview/components/feedback/feedback-list-item";

type AgentUpdatesProps = {
  isLoading: boolean;
  updates: APIListingAgentUpdateEntry[];
};
export function AgentUpdates({ updates }: AgentUpdatesProps) {
  return (
    <Card p={0}>
      <CardHeader
        p={6}
        pb={0}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Heading fontSize={"xl"} fontWeight={600} lineHeight={"28px"}>
          Agent updates
        </Heading>
        <Button to={"agent-updates"} as={Link} colorScheme={"gray"}>
          {" "}
          View all{" "}
        </Button>
      </CardHeader>
      <CardBody pt={1} pb={2} px={0}>
        <List>
          {updates?.slice(0, 3).map((update) => (
            <ListItem key={update.id} pt={3} pr={10} pb={4} pl={3}>
              <FeedbackListItem feedback={update} />
            </ListItem>
          ))}
        </List>
      </CardBody>
    </Card>
  );
}
